import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DOCUMENT } from '@angular/platform-browser';
import { FileUpload } from '../../shared/app/classes/file-upload';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { IMyDpOptions } from 'mydatepicker';
import { Router } from '@angular/router';
import { Validation } from '../../shared/app/services/validation'
import {
  PayeeAttachment, PayeeAttachmentDetail,
  PayeeService, SubmissionTag, SubmissionSubtagMapping, PayeeServiceDPE
} from '../../shared/sdk/models';
import { PayeeApi, StorageApi, PayeeSubmissionApi, PayeeServiceApi, PayeeCardsEcommerceApi } from '../../shared/sdk/services';
import { FormPage } from '../../shared/app/classes/form-page'
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from '../../shared/app/services/';
import { LoopBackConfig } from '../../shared/sdk/lb.config';
import { CONSTANT } from '../../shared/app/constants'

@Component({
  selector: 'app-jompay-documents-upload',
  templateUrl: 'jompay-documents-upload.component.html',
  providers: [
    { provide: 'Window', useValue: window },
    Validation
  ],
  styleUrls: ['../application.css']
})

export class JompayDocumentsUploadComponent extends FileUpload implements OnInit {
  @ViewChild('mdfDownload') mdfDownload: ElementRef;
  @ViewChild('cardGuideDownload') cardGuideDownload: ElementRef;
  @ViewChild('uatsoDownload') uatsoDownload: ElementRef;

  TAG = 'JompayDocumentsUploadComponent';
  CONSTANT = CONSTANT
  new: boolean = false;
  src: any;
  mobileSrc: any;
  file_name: any;
  isMobile: boolean;
  randomFileName: string;
  detail: PayeeAttachmentDetail;

  submission_tags: Array<SubmissionTag>;
  submission_subtags: Array<SubmissionSubtagMapping>;
  valid: boolean = true;

  usignedJompayLoSrc = null;
  loFilename = null;
  usignedJompaySaSrc = null;
  saFilename = null;
  usignedJompayAccAuthSrc = null;
  accAuthFilename = null;
  doneUat: boolean;
  @Input() submission: any;

  constructor(
    public payeeApi: PayeeApi,
    public payeeCardsEcommerceApi: PayeeCardsEcommerceApi,
    public payeeServiceApi: PayeeServiceApi,
    public payeeSubmissionApi: PayeeSubmissionApi,
    public router: Router,
    public storageApi: StorageApi,
    public eventManager: GlobalEventsManager,
    public validation: Validation,
    public submissionDetailService: SubmissionDetailService,
    public sanitizer: DomSanitizer,
    public http: HttpClientModule,
    @Inject(DOCUMENT) protected document: Document,
  ) {
    super(payeeApi, storageApi, eventManager);

  }

  attachment: PayeeAttachment;

  adminChecklist;
  adminChecklistRemark;

  m2uPay: PayeeServiceDPE;
  submissionId;

  attachmentsObj;

  liveDateObject: any;

  // Initialisation
  async ngOnInit() {
    this.scrollToTop();

    this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + '.pdf';
    if (window.screen.width < 1200) { // 768px portrait
      this.isMobile = true;
    }

    this.getAttachments().subscribe(
      (res: any) => {
        this.eventsManager.loaded(true);
        console.log(' === Attachments Upload: ');
        console.log("-------------carmen---------->", res);

        this.attachmentsObj = res.attachments;

        if (res.attachments.length > 0) {
          for (let attach of res.attachments) {
            switch (attach.type) {
              case 'signed_jompay_lo':
                this.usignedJompayLoSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                break;
              case 'signed_jompay_sa':
                this.usignedJompaySaSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                break;
              case 'signed_jompay_accauth':
                this.usignedJompayAccAuthSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                break;
              default: break;
            }
          }
        }
      },
      err => {
        this.eventsManager.loaded(true);
        console.log(err);
      }
    );


    // this.getFileDetails('signed_jompay_lo').subscribe(
    //   fileRes => {
    //     if (fileRes.length > 0) {
    //       console.log(this.TAG + ' getFileDetails("signed_jompay_lo")');
    //       console.log(fileRes[0]);
    //       this.loFilename = fileRes[0].file_name;
    //     }
    //   }
    // );
    console.log('Jompay Upload component');
    console.log(this.submission);
  }

  getAttachments() {
    let filter = {
      include: [{
        relation: 'attachments',
        scope: {
          where: {
            'or': [
              {
                'type': 'jompay_offer_letter',
                'isDeleted': false
              },
              {
                'type': 'signed_jompay_lo',
                'isDeleted': false
              },
              {
                'type': 'signed_jompay_sa',
                'isDeleted': false
              },
              {
                'type': 'signed_jompay_accauth',
                'isDeleted': false
              },
            ]
          },
          include: 'detail',
          order: 'created_at ASC'
        }
      },
      {
        relation: 'submission_subtags',
        scope: {
          where: {
            'deleted_at': null
          }
        }
      },
        "submission_tags",
        "payee"
      ]
    };

    return this.payeeSubmissionApi.findById(this.submission.submission_id, filter);
  }

  addEventListeners() { }

  submit(submit?: boolean) {

    this.valid = this.validate();

    if (this.valid) {
      console.log(this.TAG + ':submit');

      const fdata = {
        'tag_id': this.CONSTANT.STATUS.JOMPAY.CUSTOMER_UPLOADED_DOCUMENTS,
        'payee_id': this.submission.payee_id,
        'current': true
      }
      this.payeeSubmissionApi.createSubmission_tags(this.submission.submission_id, fdata).subscribe(
        res => {
          if (res) {
            this.eventsManager.showPopUp('Jompay documents has been submitted.');
            this.router.navigate(['/dashboard']);
            console.log('res', res)
          }
        }
      );

      // let promises = [];

      // promises.push(this.saveTechDetails());
      // Promise.all(promises)
      //   .then(
      //     res => {
      //       this.eventsManager.showPopUp('Jompay documents has been submitted.');
      //       this.router.navigate(['/dashboard']);
      //     },
      //     err => {
      //       this.eventsManager.showPopUp('Unable to submit. Please try again later');
      //     }
      //   )

    } else {
      this.eventsManager.showPopUp('Please choose file before submit.');
    }

  }

  saveTechDetails() {
    let that = this;
    let details = {
      uat_test_pop_up_sc: this.usignedJompayLoSrc,
      uat_test_rpn_sc: this.usignedJompaySaSrc,
      uat_test_rpn_sc1: this.usignedJompayAccAuthSrc,
      // uat_test_is_completed: this.doneUat
    }

    // console.log(this.payeeId);
    if (this.usignedJompayLoSrc && this.usignedJompaySaSrc && this.usignedJompayAccAuthSrc) {
    }

  }

  addDoc(name: string, event, zip, submissionId, payeeId, submissionType) {
    super.addDoc(name, event, zip, submissionId, payeeId, submissionType);


     for(var i=0; i<this.attachmentsObj.length; i++){
      if(this.attachmentsObj[i].type === name){

        const fdata = {
          "acceptance": true
        }
        this.payeeSubmissionApi.payeeAttachmentStatus(this.attachmentsObj[i].id, fdata).subscribe(
          res => {
            if (res) {
              console.log('attachment status updated..', res)
            }
          }
        );
      }
     }
  }

  deleteDoc(name: string) {
    super.deleteDoc(name);
  }

  updateDocStatus(name: string, fileName?: string) {
    switch (name) {
      case 'signed_jompay_lo':
        this.usignedJompayLoSrc = fileName;
        break;
      case 'signed_jompay_sa':
        this.usignedJompaySaSrc = fileName;
        break;
      case 'signed_jompay_accauth':
        this.usignedJompayAccAuthSrc = fileName;
        break;
    }
  };

  validateDocs() {
    this.docsValid = (this.usignedJompayLoSrc && this.usignedJompaySaSrc && this.usignedJompayAccAuthSrc);
    return this.docsValid;
  };

  validate() {
    this.valid = this.validateDocs();
    return this.valid;
  }

  // Scrolling
  scrollToTop() {
    window.scroll(0, 0);
    document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = 0;
  }

  // scrollToSave() {
  //   document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = document.getElementById('save_cards_uat_live').offsetTop;
  // }


}
